import { GetProductTracelogsVm } from './get-product-tracelogs.vm';
import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getProductTracelogs = async (
  productId: string,
  batchOrSerialNumber: string,
  offset: string,
  callback: CallbackObject<GetProductTracelogsVm>
) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  if (batchOrSerialNumber) {
    config.params.batchOrSerialNumber = batchOrSerialNumber;
  }

  try {
    const res: AxiosResponse = await instance.get(`/catalog/products/${productId}/tracelogs`, config);
    callback.success(plainToClass(GetProductTracelogsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
